/**
 * @Description this Folder contain all history manupilation functions
 * @author      Guvenc Terzierol
 */

import cloneDeep from "lodash/cloneDeep";

/**
 * @description history object contain 3 different variable.
 * first one is call past. It contain when drop any item to draggable area, it will receive current flow diagram with all attributes.
 * the present contain currently flow diagram shape provide from state
 * the future variable is contain when user go back to last situation of flow diagram, it will has last position of diagram which is stay on screen
 */
export let history = {
    past: [],
    present: [],
    future: []
}


/**
 * @description this func manage state of history object. When add a new item to flow diagram, it is set your self
 */


export const setFlowtoStorage = (key, value) => {
    sessionStorage.setItem(key, JSON.stringify(value));
}
export const getFlowFromStorage = (key) => {
    if (sessionStorage.getItem(key)) {
        return JSON.parse(sessionStorage.getItem(key))
    }
}
export const removeFlowFromStorage = (key) => {
    sessionStorage.removeItem(key);
}


export const updateHistory = (name, currentState) => {
    let clone = cloneDeep(currentState?.children);
    let cloneChildren = cloneDeep(currentState?.children);
    if (cloneChildren) {
        clone.children = [...cloneChildren]
        history.past.push(clone.children);
        setFlowtoStorage(name, clone.children)
        history.future = []
    }
}
/**
 *
 * @param name
 * @param {*} currentState it recieve a state which is provide where this func called
 * @param setState
 */
export const backward = (name, currentState, setState) => {
    if (!history.past.length) {
        return
    }
    history.future.push(currentState.children);
    history.past.pop()
    if (history.past.length !== 0) {
        const lastPastState = history.past[history.past.length - 1];
        let cloneMainState = cloneDeep(currentState);
        let cloneChildren = cloneDeep(lastPastState);
        setFlowtoStorage(name, cloneChildren)
        cloneMainState.children = [...cloneChildren];
        setState(cloneMainState)

    } else {
        const newInitialData = history.present;
        setFlowtoStorage(name, newInitialData)

    }
}

/**
 *
 * @param name
 * @param {*} currentState it recieve a state which is provide where this func called
 * @param {*} setCurrentState it set currentstate to the last piece of history.future object .
 */

export const forward = (name, currentState, setCurrentState) => {
    if (!history.future.length) {
        return
    }
    let tempArr = history.future[history.future.length - 1];
    let clone = cloneDeep(currentState);
    let cloneChildren = cloneDeep(tempArr);
    clone.children = [...cloneChildren];
    setCurrentState(clone)
    setFlowtoStorage(name, clone.children)
    history.past.push(clone.children)
    history.future.pop()
}
